module.exports = __webpack_public_path__ + "static/img/2-14-错发退货退款建单.de5793e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-14-错发退货退款建单.png
// module id = 1349
// module chunks = 0